// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"f6e59fe73713170b32b6","678":"708ba871247266b4d1ef","883":"5b4ec3be4d15a6baf5fa"}[chunkId] + ".js";
};